module.exports = __webpack_public_path__ + "static/media/345-loader-16 1.6c5a3021.svg";